import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Loading from '../generalComponets/Loading';
import Functions from '../../api/Functions';

function MessageTemplates() {
  const [showProcess, setShowProcess] = useState(false);

  const sendScheduleMessage = () => {
    setShowProcess(true);
    Functions.manualSendScheduleMessage()
      .then(() => {
        setShowProcess(false);
      })
      .catch(() => {
        setShowProcess(false);
      });
  };

  return (
    <div className="container">
      <div className="title-section">Message Templates</div>
      {showProcess ? <Loading /> : <div />}
      <div className="row">
        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>View message statistics</p>
              </div>
              <div className="card-action">
                <Link to="messageStatistics">View message statistics</Link>
              </div>
            </div>
          </div>
        </div>
        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Send schedule message</p>
              </div>
              <div className="card-action">
                <a href="#!" onClick={() => sendScheduleMessage()}>
                  Send schedule message
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MessageTemplates;
